import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const LinkIcon: React.FC<IStyleProps> = (props) => {
  return (
  <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100"><g><g><g><g><g><g><path d="M16.6,39.6c-1,3-5.9,1.7-4.8-1.3C16.3,25,27.9,14.4,41.5,11.1c24.2-5.9,48.4,15.2,46.8,39.7        c-0.7,11.4-6.8,22.1-15.9,29c-10.4,7.9-23.4,9.5-35.8,5.9c-0.2-0.1-0.4-0.2-0.6-0.3c-0.7-0.4-1.3-1.1-1.3-2.1        c0-11.7,0-23.4,0-35.1c0-1.1,0.8-1.8,0.8-1.8c0.4-0.4,1-0.7,1.7-0.7c7.3,0,14.5,0,21.8,0c-2.5-2.5-4.9-4.9-7.4-7.4        c-2.3-2.3,1.3-5.8,3.5-3.5c3.9,3.9,7.8,7.8,11.8,11.8c0.6,0.5,0.8,1.2,0.7,1.8c0,0.6-0.2,1.2-0.7,1.8        c-3.8,3.8-7.7,7.7-11.5,11.5c-2.3,2.3-5.8-1.3-3.5-3.5c2.5-2.5,4.9-4.9,7.4-7.4c-6.5,0-13,0-19.6,0c0,10.2,0,20.4,0,30.6        c13.2,3.2,26.8-0.5,35.7-11.3c8.5-10.4,10.4-24.9,4.2-36.9c-5.9-11.3-19.3-18.9-32.1-18C33.8,16.1,21,26.8,16.6,39.6z" fill={props.fillColor ?? "black"}>
  </path></g></g></g></g></g></g></svg>
  );
}

export default LinkIcon;